// extracted by mini-css-extract-plugin
module.exports = {"c-selfad-single":"_025a50318d--c-selfad-single--3ePlk"};